module.exports = __webpack_public_path__ + "img/ess.6865acb6.png";